import React from 'react';
import PropTypes from 'prop-types';

import {Dialog, DialogActions, DialogContent, DialogTitle} from 'views/components';
import {Button, TextField, Box} from 'views/components';
import {Translate, translate} from 'views/module';

const AddAuth = (props) => {
  const [email, setEmail] = React.useState('');

  const [isSetting, setIsSetting] = React.useState(false);

  const onClose = props.onClose;
  const addAuth = props.addAuth;

  const onSubmit = () => {
    setIsSetting(true);
    addAuth(email);
  };

  return (
    <Dialog onClose={onClose} open={true}>
      <DialogTitle onClose={onClose}>
        <Translate expression='caregiver.CaregiverDetail.Settings.Auth.SetupAuth' />
      </DialogTitle>
      <DialogContent>
        <Box
          sx={{
            m: 1,
          }}
        >
          <TextField
            id={'email'}
            type={'email'}
            value={email}
            onChange={setEmail}
            label={translate('caregiver.CaregiverDetail.Settings.Auth.Email')}
            fullWidth
            InputLabelProps={{shrink: true}}
            autoFocus
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' onClick={onClose}>
          <Translate expression='generic.Close' />
        </Button>
        <Button
          color="primary"
          variant="contained"
          onClick={onSubmit}
          loading={isSetting}
        >
          <Translate expression='caregiver.CaregiverDetail.Settings.Auth.SetupAuth' />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

AddAuth.propTypes = {
  onClose: PropTypes.func.isRequired,
  addAuth: PropTypes.func.isRequired,
};

export default React.memo(AddAuth);
